<template>
    <div class="animated fadeIn">
        <loading :active.sync="disabledField"></loading>
        <notifications group="foo" />
        <b-row class="text-right">
            <b-col cols="6" sm="4" md="2" class="mb-3">
                <b-button size="sm" block v-bind:variant="btnConnectClass()" v-on:click="changeWidgetStatus()" :disabled="btnChangeDisabled()">{{btnConnectText()}}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-card>
                    <div slot="header"><i class="fa fa-edit"></i><strong> Настройки</strong> </div>

                    <b-row class="mb-3">
                        <b-col sm="3"> <label for="dashboardLabel">Рабочий стол</label>  </b-col>
                        <b-col sm="9"><b-form-input id="dasboardLabel" v-model="settings.menu.dashboardLabel"></b-form-input></b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col sm="3"> <label for="leadsLabel">Сделки</label>  </b-col>
                        <b-col sm="9"><b-form-input id="leadsLabel" v-model="settings.menu.leadsLabel"></b-form-input></b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col sm="3"> <label for="customersLabel">Покупатели</label>  </b-col>
                        <b-col sm="9"><b-form-input id="customersLabel" v-model="settings.menu.customersLabel"></b-form-input></b-col>
                    </b-row class="mb-3">

                    <b-row class="mb-3">
                        <b-col sm="3"> <label for="tasksLabel">Задачи</label>  </b-col>
                        <b-col sm="9"><b-form-input id="tasksLabel" v-model="settings.menu.tasksLabel"></b-form-input></b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col sm="3"> <label for="listsLabel">Списки</label>  </b-col>
                        <b-col sm="9"><b-form-input id="listsLabel" v-model="settings.menu.listsLabel"></b-form-input></b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col sm="3"> <label for="mailLabel">Почта</label>  </b-col>
                        <b-col sm="9"><b-form-input id="mailLabel" v-model="settings.menu.mailLabel"></b-form-input></b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col sm="3"> <label for="analiticsLabel">Аналитика</label>  </b-col>
                        <b-col sm="9"><b-form-input id="analiticsLabel" v-model="settings.menu.analiticsLabel"></b-form-input></b-col>
                    </b-row class="mb-3">

                    <b-row class="mb-3">
                        <b-col sm="3"> <label for="settingsLabel">Настройки</label>  </b-col>
                        <b-col sm="9"><b-form-input id="settingsLabel" v-model="settings.menu.settingsLabel"></b-form-input></b-col>
                    </b-row>

                    <div slot="footer">
                        <b-button type="submit" :disabled="!widget.isActive" size="sm" variant="primary" v-on:click="saveSettings()"><i class="fa fa-save"></i> Сохранить</b-button>
                    </div>
                </b-card>
            </b-col>

            <b-col md="6">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header"> <i class="icon-notebook icons"></i><strong> Описание</strong></div>
                    <p>Если вас не устраивают стандартные названия пунктов основного меню, вы можете их легко заменить на свои варианты с помощью этого виджета. Например вместо "Списки" назвать раздел "Клиентская база", вместо "Сделки" - "Воронки продаж" и т.п.</p>
                </b-card>
            </b-col>
        </b-row>
  </div>
</template>

<script>
    import WidgetsService from '@/services/WidgetsService'
    import widgetEvents from '@/views/widgets/Widget';

    export default {
        mixins: [
            widgetEvents,
        ],
        components: {  }, 
        name: 'ChangeLabels',
        data () {
            return {
                widget: { isActive : false },
                widgetId: '5ce5242363b4f20e3d6465bd',
                settings: {
                    menu : {
                        dashboardLabel : '',
                        leadsLabel : '',
                        customersLabel : '',
                        tasksLabel : '',
                        listsLabel : '',
                        mailLabel : '',
                        analiticsLabel : '',
                        settingsLabel : '',
                    }
                },
                disabledField: false,
                onLoad: false
            }
        },
    };
    
</script>